// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/modules/history/historylist/index.scss
// module id = 3020
// module chunks = 13